import { Auth } from "aws-amplify";
import axios from "axios";

// const API_ENDPOINT =
//   "https://043mxmao5j.execute-api.ap-southeast-1.amazonaws.com/dev";

const API_ENDPOINT =
  "https://ccia7fz3sl.execute-api.ap-southeast-1.amazonaws.com/production";

export function getApikey(context) {
  return context.state.tempkey;
}

const initState = {
  // rooms: {
  //   all: [],
  // },
  room: null,
  // agents: [],
  channel: "main",
  selectedRoomID: null,
  // user: null,
  // credential: null,
  modal: false,
  socket: null,
  connected: false,
  tempkey: null,
};

const getters = {
  // rooms(state) {
  //   return state.rooms.all;
  // },
  room(state) {
    return state.room;
  },
  // agents(state) {
  //   return state.agents;
  // },
  channel(state) {
    return state.channel;
  },
  selectedRoomID(state) {
    return state.selectedRoomID;
  },
  // user(state) {
  //   return state.user;
  // },
  modal(state) {
    return state.modal;
  },
  // credential(state) {
  //   return state.credential;
  // },
  socket(state) {
    return state.socket;
  },
  connected(state) {
    return state.connected;
  },
  // credential(state) {
  //   return state.credential;
  // },
  tempkey(state) {
    return state.tempkey;
  },
};

const mutations = {
  // setAllRooms(state, value) {
  //   state.rooms["all"] = value;
  // },
  setRoom(state, value) {
    state.room = value;
  },
  // setAgents(state, value) {
  //   state.agents = value;
  // },
  setChannel(state, value) {
    state.channel = value;
  },
  setSelectedRoomID(state, value) {
    state.selectedRoomID = value;
  },
  // setUser(state, value) {
  //   state.user = value;
  // },
  // setModal(state, value) {
  //   state.modal = value;
  // },
  // setGuest(state, value) {
  //   state.guest = value;
  // },
  // setCredential(state, value) {
  //   state.credential = value;
  // },
  setSocket(state, value) {
    state.socket = value;
  },
  setConnected(state, value) {
    state.connected = value;
  },
  setTempkey(state, value) {
    state.tempkey = value;
  },
  reset(state) {
    state.rooms = {
      all: [],
    };
    state.room = null;
    state.agents = [];
    state.selectedRoomID = null;
    state.user = null;
    state.guessID = null;
    state.modal = false;
    state.credential = null;
    state.socket = null;
    state.connected = false;
  },
};

const actions = {
  async getToken(context, payload) {
    return context.state.tempkey;
  },

  async getRoom(context, payload) {
    const response = await axios.get(API_ENDPOINT + "/room/" + payload, {
      headers: {
        Authorization: context.state.tempkey,
      },
    });
    console.log("getRoom", response);
    if (response.status !== 200) {
      console.error("getRoom error");
      return null;
    }
    const { data } = response;
    return data;
  },

  async connectWebSocket(context) {
    // const URL = "wss://6ek73q3k35.execute-api.ap-southeast-1.amazonaws.com/dev";
    console.log("connecting websocket...");
    const URL =
      "wss://n030cqcuu2.execute-api.ap-southeast-1.amazonaws.com/production";
    const socket = new WebSocket(URL);
    context.commit("setSocket", socket);
    context.state.socket.addEventListener("open", function (event) {
      console.log(event);
      console.log("Socket connected");
      context.commit("setConnected", true);
    });

    context.state.socket.addEventListener("close", function (event) {
      console.log(event);
      context.commit("setConnected", false);
      console.log("Socket disconnected");
    });
  },

  async connectToLastRoom(context) {
    const TOKEN = context.state.tempkey;
    // const roomID = context.state.tempkey;
    // const roomID = context.state.rooms.all[0].RoomID;

    if (!TOKEN) return;
    const body = {
      action: "authorize",
      token: TOKEN,
      roomID: TOKEN,
      type: "Room",
      isCustomer: true,
      checkExists: true,
      userID: TOKEN,
    };
    context.state.socket.send(JSON.stringify(body));
  },

  // async fetchRooms(context, payload, token, data = []) {
  //   let customerID;
  //   // console.log(context.state.credential);
  //   if (context.state.user) {
  //     if (context.state.user.attributes) {
  //       if (context.state.user.attributes.sub) {
  //         customerID = context.state.user.attributes.sub;
  //       }
  //     }
  //   } else {
  //     customerID = context.state.credential.identityId;
  //   }
  //   // const customerID = "dc2cbe2a-1439-4514-854e-2f2edd1834ba";
  //   if (!customerID) {
  //     throw { code: "NO_USER_INFOMATION", messages: "User error" };
  //   }
  //   do {
  //     const response = await axios.get(
  //       API_ENDPOINT + `/rooms/customer/${customerID}`,
  //       {
  //         headers: {
  //           Authorization: await getApikey(context),
  //         },
  //         params: {
  //           nextToken: token,
  //         },
  //       }
  //     );

  //     const { Items } = response.data;
  //     token = response.data.NextToken;
  //     if (Items) {
  //       data = [...data, ...Items];
  //     }
  //   } while (token !== null);
  //   if (data.length > 0) {
  //     context.commit("setSelectedRoomID", data[0].RoomID);
  //   }
  //   console.log("Customer get rooms", data);
  //   context.commit("setAllRooms", data);
  //   // if (data.length <= 0) {
  //   //   console.log("No chat room -> create new room");
  //   //   context.dispatch("createRoom");
  //   // }
  //   return data;
  // },

  // async getRoom(context) {
  //   let customerID;
  //   if (context.state.credential) {
  //     if (context.state.credential.identityId) {
  //       customerID = context.state.credential.identityId;
  //     }
  //   }
  //   if (!customerID) {
  //     throw { code: "NO_USER_INFOMATION", messages: "user not authorized" };
  //   }
  //   const response = await axios.get(
  //     API_ENDPOINT + "/room/" + context.state.user.id,
  //     {
  //       headers: getHeader(),
  //     }
  //   );
  //   console.log("getRoom", response);
  //   if (response.status !== 200) {
  //     console.error("getRoom error");
  //   }
  //   const { data } = response;

  //   if (!data.RoomID) {
  //     throw {
  //       code: "ROOM_ID_NOT_FOUND",
  //       messages: "room ID not found!",
  //     };
  //   }

  //   const clone = data;
  //   context.commit("setRoom", clone);
  // },

  // async listAgent(context) {
  //   const API_ENDPOINT =
  //     "https://qh0mnf23g6.execute-api.ap-southeast-1.amazonaws.com/dev";
  //   const response = await axios.get(API_ENDPOINT + "/agents", {
  //     headers: getHeader(),
  //   });

  //   console.log("listAgent", response);
  //   if (response.status !== 200) {
  //     console.error("listAgent error");
  //   }

  //   const { data } = response;
  //   // console.log(context, data);
  //   context.commit("setAgents", data);
  // },

  async listMessages(context, payload) {
    const response = await axios.get(
      API_ENDPOINT + "/" + payload + "/messages",
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );

    console.log(response);
    if (response.status !== 200) {
      console.error("listMessage error");
    }

    const { data } = response;
    console.log(data);
  },

  async createRoom(context, payload) {
    console.log("Creating room", payload);
    let body;

    if (payload.isGuest) {
      body = {
        RoomID: context.state.credential.identityId,
        CreatorID: context.state.credential.identityId,
        CreatorName: payload.name,
        CustomerID: context.state.credential.identityId,
        CustomerName: payload.name,
        AllowGuest: true,
      };
    } else {
      body = {
        RoomID: context.state.user.attributes.sub,
        CreatorID: context.state.user.attributes.sub,
        CreatorName: context.state.user.attributes.name,
        CustomerID: context.state.user.attributes.sub,
        CustomerName: context.state.user.attributes.name,
        AllowGuest: false,
      };
    }

    const header = {
      Authorization: await getApikey(context),
    };

    const response = await axios.post(API_ENDPOINT + "/room", body, {
      headers: header,
    });

    console.log(response);
  },

  async createGuestRoom(context, payload) {
    const body = {
      RoomID: payload.identityId,
      CreatorID: payload.identityId,
      // from field
      CreatorName: context.state.user.username,
      CustomerID: payload.identityId,
      CustomerName: context.state.user.username,
      AllowGuest: true,
    };

    const response = await axios.post(API_ENDPOINT + "/room", body, {
      headers: {
        Authorization: await getApikey(context),
      },
    });

    console.log(response);
  },

  async closeRoom(context, roomID) {
    const response = await axios.get(
      API_ENDPOINT + "/room/" + roomID + "/close",
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );

    console.log(response);
  },

  async assignAgent(context, payload) {
    const body = {
      AgentID: payload.agentID,
      AgentName: payload.agentName,
      Channel: context.state.channel,
    };

    const response = await axios.post(
      API_ENDPOINT + "/room/" + payload.roomID + "/assign-agent",
      body,
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );

    console.log(response);
  },

  async unassignAgent(context, payload) {
    const body = {
      AgentID: payload.agentID,
      AgentName: payload.agentName,
      Channel: context.state.channel,
    };

    const response = await axios.post(
      API_ENDPOINT + "/room/" + payload.roomID + "/unassign-agent",
      body,
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );

    console.log(response);
  },

  // async assignCustomer(context, payload) {
  //   const body = {
  //     CustomerID: context.state.user.id,
  //     CustomerName: context.state.user.username,
  //   };

  //   const response = await axios.post(
  //     API_ENDPOINT +
  //       "/room/" +
  //       context.state.selectedRoomID +
  //       "/assign-customer",
  //     body,
  //     {
  //       headers: getHeader(),
  //     }
  //   );

  //   console.log(response);
  // },

  async getMessageByRoomID(context, payload) {
    console.log("getMessageByRoomID", context);
    let nextToken = null;
    let messages = [];
    if (payload.nextToken) {
      nextToken = payload.nextToken;
    }
    do {
      const response = await axios.get(
        API_ENDPOINT +
          `/room/${context.state.tempkey}/${context.state.channel}/messages`,
        {
          headers: {
            Authorization: await getApikey(context),
          },
          params: {
            nextToken: nextToken,
          },
        }
      );
      if (response.status !== 200) {
        console.error("getMessageByRoomID error");
      }

      nextToken = response.data.NextToken;
      // console.log(nextToken)
      const { Items } = response.data;
      if (Items) {
        messages = [...messages, ...Items];
      }
      if (payload.lastest) {
        break;
      }
      if (messages.length > 20) break;
    } while (nextToken);
    return { messages: messages, nextToken: nextToken };
  },

  // async getNotesByRoomID(context, payload) {
  //   let nextToken = null;
  //   let notes = [];
  //   do {
  //     const response = await axios.get(
  //       API_ENDPOINT + `/room/${payload.roomID}/notes`,
  //       {
  //         params: {
  //           nextToken: nextToken,
  //         },
  //       }
  //     );
  //     if (response.status !== 200) {
  //       console.error("getMessageByRoomID error");
  //     }

  //     nextToken = response.data.NextToken;
  //     // console.log(nextToken)
  //     const { Items } = response.data;
  //     if (Items) {
  //       notes = [...notes, ...Items];
  //     }
  //   } while (nextToken);
  //   return { notes: notes, nextToken: nextToken };
  // },

  // async addNoteToRoomID(context, payload) {
  //   const body = {
  //     CreatorID: payload.creatorID,
  //     CreatorName: payload.creatorName,
  //     Text: payload.text,
  //   };

  //   console.log("addNoteToRoomID", payload, body);

  //   const response = await axios.post(
  //     API_ENDPOINT + "/room/" + payload.roomID + "/add-note",
  //     body,
  //     {
  //       headers: headers,
  //     }
  //   );

  //   console.log(response);
  //   if (response.status !== 200) {
  //     console.error("addNote error");
  //   }
  // },

  // async getRoomsByAgentID(context, payload) {
  //   // const response = await axios.get(API_ENDPOINT + `rooms/agent/${payload}`);
  //   let nextToken = null;
  //   let rooms = [];
  //   if (payload.nextToken) {
  //     nextToken = payload.nextToken;
  //   }
  //   do {
  //     const response = await axios.get(
  //       API_ENDPOINT + `rooms/agent/${payload.agentID}`,
  //       {
  //         params: {
  //           nextToken: nextToken,
  //         },
  //       }
  //     );
  //     if (response.status !== 200) {
  //       console.error("getRoomsByAgentID error");
  //     }

  //     nextToken = response.data.NextToken;
  //     // console.log(nextToken)
  //     const { Items } = response.data;
  //     if (Items) {
  //       rooms = [...rooms, ...Items];
  //     }
  //     if (payload.lastest) {
  //       break;
  //     }
  //     // if (rooms.length > 20) break;
  //   } while (nextToken);
  //   // return { rooms: rooms, nextToken: nextToken };
  //   console.log("agent rooms", rooms);
  // },

  async typing(context) {
    const creatorID = context.state.tempkey;
    const creatorName = context.state.room.CreatorName;

    // if (context.state.user) {
    //   creatorID = context.state.user.attributes.sub;
    //   creatorName = context.state.user.username;
    // } else {
    //   creatorID = context.state.credential.identityId;
    //   creatorName = context.state.rooms.all[0].CreatorName;
    // }

    const body = {
      CreatorID: creatorID,
      CreatorName: creatorName,
    };
    const response = await axios.post(
      API_ENDPOINT + `/room/${context.state.tempkey}/typing`,
      body,
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );
    console.log(response.data);
  },

  async getImageURL(context, payload) {
    const response = await axios.get(
      // `https://043mxmao5j.execute-api.ap-southeast-1.amazonaws.com/dev/chat-image?filename=${payload}`
      API_ENDPOINT + `/chat-image?filename=${payload}`,
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );
    console.log(response);
    return response.data.URL;
  },

  async addMessage(context, payload) {
    const body = {
      SenderID: context.state.tempkey,
      Channel: context.state.channel,
      Text: payload.text,
      CustomerID: context.state.tempkey,
    };

    if (payload.nextEvent) {
      body.NextEvent = payload.nextEvent;
    }

    const response = await axios.post(
      API_ENDPOINT + "/room/" + context.state.tempkey + "/add-message",
      body,
      {
        headers: {
          Authorization: await getApikey(context),
        },
      }
    );

    console.log(response);
    if (response.status === 200) {
      return response.data.Message;
    }
    return null;
  },

  async addImageMessage(context, payload) {
    console.log("addImageMessage", payload);
    try {
      const body = new FormData();
      body.append("Channel", context.state.channel);
      body.append("SenderID", context.state.tempkey);
      body.append("CustomerID", context.state.tempkey);
      body.append("file", payload.file);

      console.log(body);

      const response = await axios.post(
        API_ENDPOINT + `/room/${context.state.tempkey}/add-image-message`,
        body,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: await getApikey(context),
          },
        }
      );
      console.log("addImageMessage response", response);
      if (response.status === 200) {
        return response.Message;
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // clearStore(context, payload) {
  //   //
  // },
};

const customerChat = {
  namespaced: true,
  state: initState,
  getters,
  actions,
  mutations,
};

export default customerChat;
